import Details from '@/components/Details/Details';
import { LanguageSelect } from '@/components/language-select/language-select.view';
import { ILocale } from '@/constants/locales';
import i18n from '@/i18n';
import IEventType from '@/types/IEventType';
import { IEventTypeWrite } from '@/types/apiClient/IEventTypeWrite';
import { Box, Heading, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';
import { FaLanguage } from 'react-icons/fa';
import TranslatedField from './components/translate-field/translate-field.view';

export interface ISectionGeneralProps {
	service: IEventType;
	onChange: (values: Partial<IEventTypeWrite>) => void;
}

export default function SectionTranslations(props: ISectionGeneralProps) {
	const locale = i18n.language as ILocale;

	const form = useForm({
		defaultValues: {
			i18n: props.service.i18n,
			locale,
		},
	});

	const onSubmit = form.handleSubmit((values) => {
		return props.onChange({
			i18n: {
				...props.service.i18n,
				...values.i18n,
			},
		});
	});

	function setValueAndSubmitForm(
		name: Parameters<typeof form.setValue>[0],
		value: Parameters<typeof form.setValue>[1]
	) {
		form.setValue(name, value);
		onSubmit();
	}

	return (
		<Details image={<FaLanguage />} title={t('Translations')}>
			<form onSubmit={console.warn}>
				<Box mb={4}>
					<LanguageSelect
						size="sm"
						label={'Language select'}
						value={form.watch('locale')}
						onChange={(v) => setValueAndSubmitForm('locale', v.value)}
					/>
				</Box>
				<Box key={form.watch('locale')}>
					<VStack w="full" p={4} borderWidth={1} borderColor="gray.200" borderRadius="md">
						<TranslatedField
							isLoading={false}
							value={form.watch(`i18n.name.${form.watch('locale')}`) ?? ''}
							onChange={(v) => {
								setValueAndSubmitForm(`i18n.name.${form.watch('locale')}`, v);
							}}
							label={t('Name')}
						/>
						<TranslatedField
							isLoading={false}
							value={form.watch(`i18n.description.${form.watch('locale')}`) ?? ''}
							onChange={(v) => {
								setValueAndSubmitForm(`i18n.description.${form.watch('locale')}`, v);
							}}
							label={t('Description')}
						/>
					</VStack>

					<VStack mt={4} w="full" p={4} borderWidth={1} borderColor="gray.200" borderRadius="md">
						<Heading size="sm" w="full">
							{t('Questions')}
						</Heading>
						{props.service.questions.map((q) => {
							return (
								<TranslatedField
									key={q.id}
									isLoading={false}
									value={form.watch(`i18n.questions.${q.id}.label.${form.watch('locale')}`) ?? ''}
									onChange={(v) => {
										setValueAndSubmitForm(`i18n.questions.${q.id}.label.${form.watch('locale')}`, v);
									}}
									label={q.label}
								/>
							);
						})}
					</VStack>
				</Box>
			</form>
		</Details>
	);
}
